import TabPage from "../../factories/tab-page";
import "../../bindings/bao-number-box";
import "../../bindings/bao-date-time-box";
import "../../bindings/bao-date-time-picker";
import "../../bindings/bao-searcher";
import * as ko from "knockout";
import Bao from "../../services/bao-service";

/**
 * Class representing a work item's universal field tab.
 */
class WorkItemUniversalFieldTab {

    //#region Fields

    WorkItem: any;
    WorkItemTabPageId: string;
    Loading = ko.observable<boolean>(false);
    UniversalFields = ko.observableArray<any>([]);
    UniversalFieldValues = ko.observableArray<any>([]);
    TemplateName = ko.observable<string>("");
    TemplateContext = ko.observable<any>(null);
    IsHistory = ko.observable<boolean>(false);
    TabPage: any;

    /**
     * SessionTabId 
     */
    SessionTabId = ko.observable("");

    /**
     * Store the info if the WorkItem is a WorkItem Series 
     */
    InitBasedOnSerialTask: KnockoutObservable<boolean> = ko.observable(false);

    /**
     * Parent WorkItemId (the "parent" for series elements)
     */
    ParentWorkItemId: KnockoutObservable<boolean> = ko.observable(false);

    //#endregion

    //#region Constructors

    /**
     * Initializes a new instance of the WorkItemUniversalFieldTab class.
     * @param {TabPage} TabPage - The tab page.
     * @param {any} parent - The parent.
     */
    constructor(public tabPageInstance: TabPage, parent: any) {
        this.WorkItem = parent;
        this.TabPage = tabPageInstance;
        this.WorkItemTabPageId = tabPageInstance.Id();

        this.ParentWorkItemId(parent.PrimaryWorkItemId())
        if (parent.IsBasedOnVirtual()) {
            this.InitBasedOnSerialTask(true);
        }
        this.SessionTabId(parent.TabPage.SessionTabId);

        // Subscribe to parent's DirtyFlag
        tabPageInstance.DirtyFlag.subscribe((isDirty: boolean) => {
            if (isDirty) {
                this.WorkItem.TabPage.DirtyFlag(true);
            }
        });
    }

    //#endregion

    //#region Public Methods

    /**
     * Refreshes the tab.
     * @returns {JQueryPromise<void>}
     */
    Refresh(): JQueryPromise<void> {
        return this.UpdateValues()
            .then(() => {
                this.TabPage.DirtyFlag.reset();
            });
    }

    /**
     * Saves the tab's data.
     * @param {any} version - The version.
     * @returns {JQueryPromise<any>}
     */
    Commit(version: any): JQueryPromise<any> {
        // Implement save logic here
        this.Loading(true);
        this.TabPage.IsLoading(true);
        return Bao.post("WorkItemUniversalFieldTab/SaveUniversalFieldValues", JSON.stringify({
            models: ko.toJS(this.UniversalFieldValues()),
            workItemTabId: this.WorkItemTabPageId,
            version: version
        }), (result) => {
            this.Loading(false);
            this.TabPage.IsLoading(false);
            this.TabPage.DirtyFlag(false);
        });
    }

    /**
     * Initializes the tab.
     * @returns {JQueryPromise<any>}
     */
    init(): JQueryPromise<any> {
        return this.UpdateTab();
    }

    //#endregion

    //#region Protected Methods

    /**
     * Updates the tab.
     * @returns {JQueryPromise<any>}
     */
    protected UpdateTab(): JQueryPromise<any> {
        const def = $.Deferred();
        this.TemplateName(null);
        this.TemplateContext(null);

        return Bao.post("WorkItemUniversalFieldTab/GetUniversalFields", JSON.stringify({
            workItemTabId: this.WorkItemTabPageId
        }), (result) => {
            const htmlUrl = "WorkItemUniversalFieldTabTemplate" + this.WorkItemTabPageId;
            this.UniversalFields(result.Models);

            return this.UpdateValues().then(() => {
                Bao.Templates[htmlUrl] = result.html;
                this.TemplateName(htmlUrl);
                def.resolve();
            });
        });
    }

    /**
     * Updates the values.
     * @returns {JQueryPromise<any>}
     */
    protected UpdateValues(): JQueryPromise<any> {
        return Bao.post("WorkItemUniversalFieldTab/GetUniversalFieldValues", JSON.stringify({
            workItemId: this.WorkItem.WorkItemId(),
            workItemTabId: this.WorkItemTabPageId,
            customFilter: this.CustomFilter(),
            sessionTabId: this.SessionTabId()
        }), (result) => {
            ko.map.fromJS(result, this, this.TabPage.DirtyFlag);
            this.TemplateContext(this);
        });
    }

    /**
     * Returns custom filters
     * @returns Custom filters
     */
    protected CustomFilter(): Models.HashObject[] {
        let customFilterHashObject: Models.HashObject[] = [];
        if (this.InitBasedOnSerialTask()) {
            customFilterHashObject.push({
                Key: 'WorkItemId',
                Value: this.ParentWorkItemId()
            });
            customFilterHashObject.push({
                Key: 'BaseOnSerialTask',
                Value: true
            });
        }
        return customFilterHashObject;
    }

    //#endregion

    //#region Additional Methods and Logic

    /**
     * Retrieves the observable tag based on the universal field ID.
     * @param {any} universalFieldId - The universal field ID.
     * @returns {any}
     */
    getTagObservable(universalFieldId: any): any {
        return this.UniversalFieldValues().find(item => ko.unwrap(item.UniversalFieldId) === universalFieldId);
    }

    /**
     * Retrieves the model tag based on the universal field ID.
     * @param {any} universalFieldId - The universal field ID.
     * @returns {any}
     */
    getTagModel(universalFieldId: any): any {
        return this.UniversalFields().find(item => ko.unwrap(item.UniversalFieldId) === universalFieldId);
    }

    /**
     * Checks if the item is complete.
     * @param {any} item - The item to check.
     * @returns {JQueryPromise<boolean>}
     */
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }

    /**
     * Pauses the dirty flag.
     */
    pauseDirtyFlag(): void {
        this.TabPage.DirtyFlag.pause();
    }

    /**
     * Resumes the dirty flag.
     */
    resumeDirtyFlag(): void {
        this.TabPage.DirtyFlag.resume();
    }

    //#endregion

}
export default WorkItemUniversalFieldTab;